import { useQuery } from '@tanstack/react-query';
import * as completenessApi from '../completeness.api';

export function useClientScores(enabled = true) {
  return useQuery({
    queryKey: ['completeness', 'clients'],
    queryFn: completenessApi.getClientSummaries,
    enabled,
  });
}

/** h4-4/FR28: klantoverzicht-verrijking (openstaande orders + trend). Independent query — its
 * own loading/error state never blocks the base client list from rendering. */
export function useClientsEnrichment(enabled = true) {
  return useQuery({
    queryKey: ['completeness', 'clients', 'enrichment'],
    queryFn: completenessApi.getClientsEnrichment,
    enabled,
  });
}
